import Vue from 'vue';
import VueI18n, { DateTimeFormats, NumberFormats } from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages(): VueI18n.LocaleMessages {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: VueI18n.LocaleMessages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const dateTimeFormats: DateTimeFormats = {
  en: {
    short: { year: 'numeric', month: 'long', day: 'numeric' },
    long: {
      year: 'numeric', month: 'short', day: 'numeric', weekday: 'short', hour: 'numeric', minute: 'numeric',
    },
  },
  nl: {
    short: { year: 'numeric', month: 'numeric', day: 'numeric' },
    long: {
      year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short', hour: 'numeric', minute: 'numeric',
    },
  },
};

const numberFormats: NumberFormats = {
  en: { currency: { style: 'currency', currency: 'EUR' } },
  nl: { currency: { style: 'currency', currency: 'EUR' } },
};

export default new VueI18n({
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: loadLocaleMessages(),
  dateTimeFormats,
  numberFormats,
});
